<script setup lang="ts">
import { crmPrices, crmComparePlans } from "~/data/prices/crm";

const props = defineProps<{
    title: string,
    desc: string,
}>();
const isShowComparePlans = ref(false);
const userCount = ref(10);

const prices = computed(() => {
    return crmPrices.map(pricing => ({
        ...pricing,
        amounts: pricing.amounts.map(amount => {
            if (!Array.isArray(amount.value)) return { ...amount };
            const matchedTier = amount.value.find(item => {
                const min = item.min ?? 1;
                const max = item.max ?? Infinity;
                return userCount.value >= min && userCount.value <= max;
            });

            if (!matchedTier) return { ...amount };
            return { 
                ...amount, 
                value: formatPrice(matchedTier.price) 
            };
        })
    }));
});
</script>

<template>
    <SectionsPricesBase :title="props.title" :desc="props.desc">
        <SectionsPricesCrmUsersRange 
            v-model="userCount" 
            class="mt-15"
        />
        <div class="w-full flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-6 mt-12 lg:mt-15">
            <LazyCardsPricing
                v-for="item in prices"
                :key="item.title"
                :item="item"
                class="max-w-82.5!"
            />
        </div>
        <Accordion v-model="isShowComparePlans" class="my-8">
            <template #head="{ isOpen, toggleAccordion }">
                <Button
                    type="Secondary"
                    :append-icon="{ 
                        name: isOpen 
                            ? 'solar:round-alt-arrow-up-bold' 
                            : 'solar:round-alt-arrow-down-bold' 
                    }"
                    pill
                    class="mx-auto"
                    @click="toggleAccordion"
                >
                    مقایسه ویژگی‌ها
                </Button>
            </template>
            <template #body>
                <LazySectionsPricesComparePlans 
                    v-if="isShowComparePlans" 
                    :plans="crmComparePlans"
                    class="my-8" 
                />
            </template>
        </Accordion>
    </SectionsPricesBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.yellow-label {
    @apply
    w-fit lg:w-91.25 flex justify-center items-center mx-auto py-2 px-2 lg:px-0 bg-secondary-600 
    rounded-full shadow-gray-m text-center
}
</style>